/* eslint-disable no-nested-ternary */
import * as pathUtils from '../utils/path';

// eslint-disable-next-line -- NOTE (@mbae, 06/10/24): process.env should NOT be destructured in Next.js
const environment = process.env.environment;

export const getRobloxDomain = () => {
  if (environment === 'production') {
    return 'roblox.com';
  }

  if (environment === 'development') {
    return 'sitetest3.robloxlabs.com';
  }

  // For example, when environment is 'staging'
  return 'sitetest1.robloxlabs.com';
};

export const getRobloxEnvironment = () => {
  if (environment === 'production') {
    return 'production';
  }

  if (environment === 'development') {
    return 'sitetest3';
  }

  return 'sitetest1';
};

/**
 * Convert the Roblox domain in the URL for environment consistency
 */
export const convertRobloxUrlToCurrentEnvironment = (url: string): string => {
  const targetDomain = getRobloxDomain();

  if (url.includes('roblox.com')) {
    return url.replace(/roblox\.com/, targetDomain);
  }

  if (url.includes('sitetest3.robloxlabs.com')) {
    return url.replace(/sitetest3\.robloxlabs\.com/, targetDomain);
  }

  return url.replace(/sitetest1\.robloxlabs\.com/, targetDomain);
};

export const getCreatorHubBaseUrl = () => {
  if (process.env.pullRequestNumberString) {
    return `https://${process.env.pullRequestNumberString}.create.${getRobloxDomain()}`;
  }

  return `https://create.${getRobloxDomain()}`;
};

export const creatorHubBaseUrl = getCreatorHubBaseUrl();
export const creatorHubSettingsPreferencesPageUrl = new URL(
  pathUtils.join('settings', 'preferences'),
  creatorHubBaseUrl,
).href;

export const getCreatorHubDocsBaseUrl = () => {
  return `${creatorHubBaseUrl}/docs`;
};

export function getBedev2BaseUrl() {
  return `https://apis.${getRobloxDomain()}`;
}

export const bedev2BaseUrl = getBedev2BaseUrl();

export function getBEDEV1ServiceBasePath(serviceName: string) {
  return `https://${serviceName}.${getRobloxDomain()}`;
}

export function getBEDEV2ServiceBasePath(serviceName: string) {
  return `${bedev2BaseUrl}/${serviceName}`;
}

export function getEventBasePath() {
  return getBEDEV1ServiceBasePath('ecsv2');
}

function getSignalRConnectionUrl() {
  if (environment === 'production') {
    return 'https://realtime-signalr.roblox.com/userhub';
  }

  const domainPrefix = environment === 'staging' ? 'snc2-' : '';
  return `https://${domainPrefix}realtime-signalr.${getRobloxDomain()}/userhub`;
}

const baseUrl = getCreatorHubDocsBaseUrl();

export const forumBaseUrl = 'https://devforum.roblox.com';

export const signalrConnectionUrl = getSignalRConnectionUrl();

export default baseUrl;
